import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MsdAiShowcaseComponent } from './msd-ai-showcase.component';

const routes: Routes = [
  {
    path: '',
    component: MsdAiShowcaseComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MsdAiShowcaseRoutingModule {}
